export const mainPath = window.location.href.split('#')[0]
